import { Base } from "ui/Scripts/source/framework/base";

/* eslint-disable no-unused-vars */
export enum EventTypeCategory {
    A,
    B,
    C
}
/* eslint-enable no-unused-vars */

export interface IEventEventType {
    id: string;
    eventTypeId: string;
    eventTypeCategory: number;
    modifyDate: number;

    isNew(): boolean;
}

export class EventEventType implements IEventEventType {
    id: string;
    eventTypeId: string;
    eventTypeCategory: number;
    modifyDate: number;

    constructor();
    constructor(obj: IEventEventType);
    constructor(obj?: any) {
        this.id = obj && obj.id || "";
        this.eventTypeId = obj && obj.eventTypeId || "";
        this.eventTypeCategory = obj && obj.eventTypeCategory || 0;
        this.modifyDate = obj && obj.modifyDate || 0;
    }

    isNew(): boolean {
        return this.modifyDate === 0;
    }

    static createEventEventType(eventTypeId: string, eventTypeCategory: number): EventEventType {
        const eventEventType = new EventEventType();
        eventEventType.id = Base.getGuid();
        eventEventType.eventTypeId = eventTypeId;
        eventEventType.eventTypeCategory = eventTypeCategory;
        return eventEventType;
    }

    static getFirstEventTypeId(eventEventTypes: IEventEventType[], eventTypeCategory: number): string {
        if (Base.isNullOrUndefined(eventEventTypes)) return "";
        for (let i = 0; i < eventEventTypes.length; i++) {
            if (eventEventTypes[i].eventTypeCategory !== eventTypeCategory) continue;
            return eventEventTypes[i].eventTypeId;
        }
        return "";
    }

    static getEventTypeIds(eventEventTypes: IEventEventType[], eventTypeCategory: number): string[] {
        if (!eventEventTypes) return [];
        const result: string[] = [];
        for (let i = 0; i < eventEventTypes.length; i++) {
            if (eventEventTypes[i].eventTypeCategory !== eventTypeCategory) continue;
            result.push(eventEventTypes[i].eventTypeId);
        }
        return result;
    }
}
